/**
 * Validation for file size
 * 1048576 is 1MB
 */
const imageUploadSizeMax = value => {
  // it's not required
  if (!value) {
    return true;
  }
  return value.size < 1048576;
};

/**
 * This promisified validator makes sure that the image is exactly square
 */
const imageDimensionsAreSquare = value => {
  // it's not required
  if (!value) {
    return true;
  }

  return new Promise(resolve => {
    let reader = new FileReader();
    reader.readAsDataURL(value);

    reader.onload = event => {
      let image = new Image();

      image.onload = () => {
        resolve(image.width == image.height);
      };

      image.src = event.target.result;
    };
  });
};

const validZipcode = value => !value || Boolean(value.match(/[0-9]{5}/));

const validLatitude = value => value === "" || (value >= -90 && value <= 90);

const validLongitude = value => value === "" || (value >= -180 && value <= 180);

const validDollarsAndCents = value => {
  return (
    !value ||
    Boolean(
      String(value).match(
        /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/
      )
    )
  );
};

const mustBeArray = value => Array.isArray(value);

export {
  imageUploadSizeMax,
  imageDimensionsAreSquare,
  validZipcode,
  validLatitude,
  validLongitude,
  validDollarsAndCents,
  mustBeArray
};
